
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import MoviesDataType from '../Interface/Interface';

export default function Movies() {

  const [moviesList, setMoviesList] = useState([]);


  const [pageNumber, setPageNumber] = useState(1)
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sliderNumber, setsliderNumber] = useState(1)


  useEffect(() => {
    getPopularMovies(pageNumber);
    setLoading(true);
  }, [])

  useEffect(() => {
    getPopularMovies(pageNumber);
    setLoading(true);
    setsliderNumber(sliderNumber + 1)

  }, [pageNumber])

  function getDetails(id: number, type: string) {
    sessionStorage.setItem('movieID', JSON.stringify(id));
    sessionStorage.setItem('movieType', type);

    navigate('/details')
  }
  async function getPopularMovies(pageNumber: number) {
    const { data } = await axios.get(`https://api.themoviedb.org/3/movie/popular?api_key=52554469fe208e948caaf074d2683e95&language=en-US&page=${pageNumber}`);



    setMoviesList(data.results)
    setLoading(false)

  }

  return (<>
    {loading ? <div className='loaddrComtainer '>
      <span className="loader"></span>
    </div> :
      <>
        <h2 className='py-2 text-center main-head p-3'>  popular Movies to watch</h2>

        <div className="row py-3 text-center">

          {moviesList.map((el: MoviesDataType, index) => <div className='col-md-2 movie-item py-3' key={index} onClick={() => getDetails(el.id, 'movie')} >

            <img src={`https://image.tmdb.org/t/p/w500/` + el.poster_path} className='img-fluid pb-1 ' alt={el.title} />




            <h5 className='votes p-1'>{el.vote_average.toString().slice(0, 3)}</h5>
            {el.title.length < 15 ? <h5 >{el.title}</h5 > : <h5 >{el.title.slice(0, 15)}...</h5 >}

          </div>
          )}
          <nav aria-label="Page navigation example ">


            <ul className="pagination justify-content-center ">



              <li className="page-item ">

                <a className="page-link" onClick={() => (pageNumber == 1 ? '' : setPageNumber(pageNumber - 1))}>Previous</a>
              </li>

              <li className="page-item"><a className="page-link" onClick={() => setPageNumber(1)} >{sliderNumber}</a></li>
              <li className="page-item"><a className="page-link" onClick={() => setPageNumber(sliderNumber + 1)} >{sliderNumber + 1}</a></li>

              <li className="page-item"><a className="page-link" onClick={() => setPageNumber(sliderNumber + 2)} >{sliderNumber + 1}</a></li>
              <li className="page-item"><a className="page-link" onClick={() => setPageNumber(sliderNumber + 3)} >{sliderNumber + 2}</a></li>
              <li className="page-item"><a className="page-link" onClick={() => setPageNumber(sliderNumber + 4)} >{sliderNumber + 3}</a></li>
              <li className="page-item"><a className="page-link" onClick={() => setPageNumber(sliderNumber + 5)} >{sliderNumber + 4}</a></li>
              <li className="page-item"><a className="page-link" onClick={() => setPageNumber(sliderNumber + 6)} >{sliderNumber + 5}</a></li>
              <li className="page-item"><a className="page-link" onClick={() => setPageNumber(sliderNumber + 7)} >{sliderNumber + 6}</a></li>
              <li className="page-item"><a className="page-link" onClick={() => setPageNumber(sliderNumber + 8)} >{sliderNumber + 7}</a></li>
              <li className="page-item">

                <a className="page-link" onClick={() => (setPageNumber(pageNumber + 1))} >Next</a>
              </li>
            </ul>

          </nav>

        </div>
      </>
    }
  </>
  )
}
